import { selectActiveDocumentationPageTab } from '../../reducers/documentation/documentationPageReducer';
import { useSelector } from 'react-redux';
import { TagsCenter } from './tags-center/TagsCenter';
import { UsersCenter } from './tags-center/UsersCenter';
import { Stack } from '@mui/material';
import { useExpandedMode } from '../pages/configuration-canvas/panels-reserve-space/useExpandedMode';

interface TagsAndUsersWrapperProps {
  onCloseDialog?: () => void;
  crmOrgId: string;
}

const Wrapper = ({
  children,
  isExpandedMode,
}: {
  children: React.ReactNode;
  isExpandedMode: boolean;
}) => {
  return (
    <Stack pt={isExpandedMode ? 3 : 0} height="100%" width="100%">
      {children}
    </Stack>
  );
};

export const TagsAndUsersWrapper = ({ onCloseDialog, crmOrgId }: TagsAndUsersWrapperProps) => {
  const activeTab = useSelector(selectActiveDocumentationPageTab);
  const { isExpandedMode } = useExpandedMode();

  if (activeTab === 'tags') {
    return (
      <Wrapper isExpandedMode={isExpandedMode}>
        <TagsCenter onCloseDialog={onCloseDialog} crmOrgId={crmOrgId} />
      </Wrapper>
    );
  }

  if (activeTab === 'users') {
    return (
      <Wrapper isExpandedMode={isExpandedMode}>
        <UsersCenter onCloseDialog={onCloseDialog} crmOrgId={crmOrgId} />
      </Wrapper>
    );
  }
};
